'use es6';

import * as ActionTypes from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
export const getSearchTags = () => dispatch => {
  dispatch({
    type: ActionTypes.STOREFRONT_SEARCH_TAGS_REQUESTED
  });
  ecosystemClient.getSearchTags().then(({
    tags
  }) => {
    dispatch({
      type: ActionTypes.STOREFRONT_SEARCH_TAGS_RECEIVED,
      payload: tags
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.STOREFRONT_SEARCH_TAGS_FAILED,
      payload: error
    });
  });
};
export const getUnusedFilters = () => dispatch => {
  dispatch({
    type: ActionTypes.STOREFRONT_UNUSED_FILTERS_REQUESTED
  });
  ecosystemClient.getUnusedFilters().then(resp => {
    dispatch({
      type: ActionTypes.STOREFRONT_UNUSED_FILTERS_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.STOREFRONT_UNUSED_FILTERS_FAILED,
      payload: error
    });
  });
};